<template>
  <v-layout row align-center>
    <v-flex ml-1>
      <v-select v-model="yearValue" :items="allowedYears" solo label="Año"></v-select>
    </v-flex>
    <v-flex ml-1>
      <v-select
        v-model="monthValue"
        :items="allowedMonths"
        item-text="label"
        item-value="number"
        solo
        label="Mes"
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    label: {
      type: String,
    },
    value: {
      type: [String, Object, Array],
    },
    allowedYears: {
      type: [Array, Object],
      default() {
        const startYear = new Date().getFullYear() - 4;
        const res = [];
        const month = new Date().getMonth() + 1;
        // If it is november or december we add the next year in the range
        const yearsToTake = month >= 11 ? 6 : 5;

        for (let i = 0; i < yearsToTake; i++) {
          const year = String(startYear + i);
          res.push(year);
        }
        return res;
      },
    },
    allowedMonths: {
      type: [Array, Object],
      default() {
        return [
          { number: '01', label: 'ENE' },
          { number: '02', label: 'FEB' },
          { number: '03', label: 'MAR' },
          { number: '04', label: 'ABR' },
          { number: '05', label: 'MAY' },
          { number: '06', label: 'JUN' },
          { number: '07', label: 'JUL' },
          { number: '08', label: 'AGO' },
          { number: '09', label: 'SEP' },
          { number: '10', label: 'OCT' },
          { number: '11', label: 'NOV' },
          { number: '12', label: 'DIC' },
        ];
      },
    },
    error: {
      type: String,
    },
  },
  data() {
    return {
      yearValue: null,
      monthValue: null,
      menu: false,
    };
  },
  computed: {
    yearMonth() {
      const year = this.yearValue ? this.yearValue : '';
      const month = this.monthValue ? '-' + this.monthValue : '';
      return year + month;
    },
  },
  methods: {
    cancel() {
      this.menu = false;
      this.time = null;
    },
    allowedYearsComputed(t) {
      console.log('allowedYearsComputed', t, this.allowedYears);

      if (this.allowedYears && Array.isArray(this.allowedYears)) {
        return this.allowedYears.includes(String(t));
      } else {
        return true;
      }
    },
    allowedMonthsComputed(m) {
      console.log('allowedMonthsComputed', m, this.allowedMonths);
      if (this.allowedMonths && Array.isArray(this.allowedMonths)) {
        return this.allowedMonths.includes(String(m));
      } else {
        return true;
      }
    },
  },
  watch: {
    value: function(val, oldVal) {
      console.log('value', this.value);
      if (val) {
        const splitDate = this.value.split('-');
        this.yearValue = splitDate[0] ? splitDate[0] : '';
        this.monthValue = splitDate[1] ? splitDate[1] : '';
      } else {
        this.yearValue = '';
        this.monthValue = '';
      }
    },
    yearMonth: function(val, oldVal) {
      this.$emit('input', this.yearMonth);
    },
  },
};
</script>

<style></style>
